
import {
    UPDATE_MINI_CART_FLAG
  } from '../middleware/types'
const initialState = {
    SUBMIT_loading: false,
    error: {},
}

export default (state = initialState, action) => {
    switch (action.type) {
        case UPDATE_MINI_CART_FLAG:
            return {
                ...state,
                SUBMIT_loading: false,
                updateMiniCartFlag: action.updateMiniCartFlag,
            }
        default:
            return state
    }
}

